import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IFilterData } from '../../../core/models/filter-data.model';
import { IMetricRange } from '../../../core/models/metric-range.model';
import { IProduct } from '../../../core/models/product.model';
import { ListingDisplayMode } from '../../../core/models/display-mode.enum';
import { ISideMenuItemModel } from '../../models/side-menu-item.model';

@Component({
    selector: 'lynkd-pattern-application-breadcrumbs',
    templateUrl: './application-breadcrumbs.component.html',
    styleUrls: ['./application-breadcrumbs.component.scss']
})
export class ApplicationBreadcrumbsComponent {
    @Input()
    public filterData: IFilterData;
    // eslint-disable-next-line @typescript-eslint/typedef
    public ListingDisplayMode = ListingDisplayMode;
    @Input()
    public gallery: ListingDisplayMode;
    @Input()
    public filtersApplied: boolean = true;
    @Input()
    public sideMenuConfig: Array<ISideMenuItemModel>;

    @Output()
    public readonly mainFilterRemoved: EventEmitter<{ filter: 'location' | 'time' | keyof IFilterData; filterItem?: string }> =
        new EventEmitter<{ filter: 'location' | 'time' | keyof IFilterData; filterItem?: string }>();
    @Output()
    public readonly filterRemoved: EventEmitter<{
        filter: keyof IFilterData;
        filterItem: string | IMetricRange;
        subFilter?: string;
    }> = new EventEmitter<{
        filter: keyof IFilterData;
        filterItem: string | IMetricRange;
        subFilter?: string;
    }>();
    @Output()
    public readonly mainExclusionRemoved: EventEmitter<void> = new EventEmitter<void>();
    @Output()
    public readonly exclusionRemoved: EventEmitter<string | IProduct> = new EventEmitter<string | IProduct>();
    @Input()
    public checkActiveMetricRanges: boolean;
    // eslint-disable-next-line @typescript-eslint/typedef
    public listingDisplayMode = ListingDisplayMode;

    public removeMainFilter(filter: 'location' | 'time' | keyof IFilterData, filterItem?: string): void {
        this.mainFilterRemoved.emit({ filter, filterItem });
    }

    public removeFilter(
        filter: keyof IFilterData,
        filterItem: string | IMetricRange,
        subFilter?: string
    ): void {
        this.filterRemoved.emit({ filter, filterItem, subFilter });
    }

    public removeMainExclusion(): void {
        this.mainExclusionRemoved.emit();
    }

    public removeExclusion(exclusion: string | IProduct): void {
        this.exclusionRemoved.emit(exclusion);
    }

    /**
     * The configured display name for a filter breadcrumb, or '' when the config does not describe it.
     *
     * Every hop is optional on purpose. sideMenuConfig is an @Input that callers are free not to
     * supply, and this is called from inside the filter chips -- so an unguarded dereference here
     * takes down the whole page the moment a chip renders, which is exactly what happened on
     * Allocations. A missing node at any level means "no display name", never a thrown error.
     */
    public getBreadCrumbHeader(title: string, parentType: string): string {
        // Get Filters
        const filters: ISideMenuItemModel = this.sideMenuConfig?.find(
            (value: ISideMenuItemModel) => value.name === 'filters'
        );

        // Get the side menu types by comparing the name with the parentType parameter.
        const sideMenuTypes: ISideMenuItemModel = filters?.children?.[0]?.children?.find(
            (filterItem: ISideMenuItemModel) => filterItem.name?.toLowerCase() === parentType
        );

        // This finds the display name by comparing the child name with the title parameter.
        const displayNames: ISideMenuItemModel = sideMenuTypes?.children?.find(
            (child: ISideMenuItemModel) => child.name === title
        );

        return displayNames?.displayName ?? '';
    }

}
